export default "__VITE_PUBLIC_ASSET__8e8f6e86__"